const statuses = [
  [3, 'Applicant', 'App'],
  [7, 'Onboarding', 'Onb'],
  [5, 'Review', 'Rev'],
  [6, 'Accepted', 'Accep'],
  [0, 'Blocked', 'Block'],
  [1, 'Inactive', 'Inac'],
  [2, 'Active', 'Act'],
  [4, 'Online', 'On'],
]

export {
  statuses
}
